<template>
  <div class="row">
    <div class="container container-folder-structure">
      <table class="table table-borderless">
        <tbody class="body">
          <folder-tree></folder-tree>
        </tbody>
      </table>
    </div>
    <div class="container container-folder-details">
      <table class="table table-borderless">
        <tbody class="body">
          <tr>
            <td class="col-6 head">No. of Files</td>
            <td class="col-6 head">Folder Size</td>
          </tr>
          <tr>
            <td
              v-if="typesenseStore.currentContent?.files_count == null"
              class="content"
            >
              -
            </td>
            <td v-else class="content">
              {{ typesenseStore.currentContent?.files_count }}
            </td>
            <td
              v-if="typesenseStore.currentContent?.size == null"
              class="content"
            >
              -
            </td>
            <td v-else class="content">
              {{
                $filters.formatSizeUnits(typesenseStore.currentContent?.size)
              }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup lang="ts">
import FolderTree from "../FolderTree.vue";
import { useTypesenseStore } from "@/stores/typesense";

const typesenseStore = useTypesenseStore();
</script>

<style lang="scss" scoped>
.container-folder-structure {
  background: #ebebeb;
  display: flex;
  margin-top: 16px;
  padding: 16px;
  padding-bottom: 0;
  max-width: 96%;
  overflow: auto;
}
.container-folder-details {
  display: flex;
  padding: 16px;
  padding-bottom: 0;
  max-width: 96%;
  overflow: auto;
}
</style>
